import { NotificationLogEntryType } from "@/model/Patient"

/**
 * Returns the background color class for a notification type
 */
export const notificationTypeBgColor = (
  type: NotificationLogEntryType
): string => {
  switch (type) {
    // Hypertension alerts
    case "LOW_BLOOD_PRESSURE":
      return "bg-blue-100"
    case "ELEVATED_BLOOD_PRESSURE":
      return "bg-purple-100"
    case "CRITICAL_BLOOD_PRESSURE":
      return "bg-rose-100"
    case "HYPERTENSION_REVIEW":
      return "bg-indigo-100"
    case "HYPERTENSION_TIGHTENED_CONTROL":
      return "bg-violet-100"
    case "WEEKLY_HYPERTENSION_REPORT":
      return "bg-sky-100"
    // Diabetes alerts
    case "EMERGENCY_LOW_BLOOD_GLUCOSE":
      return "bg-pink-100"
    case "CRITICAL_LOW_BLOOD_GLUCOSE":
      return "bg-fuchsia-100"
    case "DIABETES_REVIEW":
      return "bg-cyan-100"
    case "DIABETES_TIGHTENED_CONTROL":
      return "bg-teal-100"
    case "WEEKLY_DIABETES_REPORT":
      return "bg-slate-100"
    default:
      return "bg-gray-100"
  }
}

/**
 * Returns the line color class for a notification type
 * Used for the horizontal line in table view
 */
export const notificationTypeIndicatorColor = (
  type: NotificationLogEntryType
): string => {
  switch (type) {
    // Hypertension alerts
    case "LOW_BLOOD_PRESSURE":
      return "bg-blue-500"
    case "ELEVATED_BLOOD_PRESSURE":
      return "bg-purple-500"
    case "CRITICAL_BLOOD_PRESSURE":
      return "bg-rose-500"
    case "HYPERTENSION_REVIEW":
      return "bg-indigo-500"
    case "HYPERTENSION_TIGHTENED_CONTROL":
      return "bg-violet-500"
    case "WEEKLY_HYPERTENSION_REPORT":
      return "bg-sky-500"
    // Diabetes alerts
    case "EMERGENCY_LOW_BLOOD_GLUCOSE":
      return "bg-pink-500"
    case "CRITICAL_LOW_BLOOD_GLUCOSE":
      return "bg-fuchsia-500"
    case "DIABETES_REVIEW":
      return "bg-cyan-500"
    case "DIABETES_TIGHTENED_CONTROL":
      return "bg-teal-500"
    case "WEEKLY_DIABETES_REPORT":
      return "bg-slate-500"
    default:
      return "bg-gray-500"
  }
}
